import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';

export const projectTargetModelIdSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) => project?.targetModelId || ''
  );
